import IntegrationView from './IntegrationView';
import './IntegrationView.scss';

export default IntegrationView;
